import script from "./Growth_Items.vue?vue&type=script&setup=true&lang=ts"
export * from "./Growth_Items.vue?vue&type=script&setup=true&lang=ts"

import "./Growth_Items.vue?vue&type=style&index=0&id=927bda70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-927bda70"]])

export default __exports__